import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import componentsLibraryThemeObject from "@powerdiary/components-library/lib/theme";

import { ClientPortalErrorBoundary } from "./components/ErrorPages/ClientPortalErrorBoundary";
import { queryClient } from "./queryClient";
import { SnackbarProvider } from "@powerdiary/components-library/lib";
import { setupClientPortalStore } from "./redux";
import { Provider as ReduxProvider } from "react-redux";
import ClientPortalRouter from "./ClientPortalRouter";

import "./ClientPortal.module.css";
interface IClientPortal {
    mountPointSelector: string;
    clientPortalGuid: string;
}

const clientPortalStore = setupClientPortalStore();
const defaultTheme = createTheme(componentsLibraryThemeObject);

export const renderClientPortal = ({ mountPointSelector, clientPortalGuid }: IClientPortal) => {
    const container = document.getElementById(mountPointSelector);
    const root = createRoot(container);

    root.render(
        <ThemeProvider theme={defaultTheme}>
            <CssBaseline />
            <ClientPortalErrorBoundary>
                <QueryClientProvider client={queryClient}>
                    <LocalizationProvider dateAdapter={AdapterLuxon}>
                        <SnackbarProvider>
                            <ReduxProvider store={clientPortalStore}>
                                <ClientPortalRouter clientPortalGuid={clientPortalGuid} />
                            </ReduxProvider>
                        </SnackbarProvider>
                    </LocalizationProvider>
                </QueryClientProvider>
            </ClientPortalErrorBoundary>
        </ThemeProvider>
    );
};
